module.exports = __webpack_public_path__ + "static/images/help-center.1sdNlG8.svg";